const FaqsFilter = function () {
  const slug = '/blogs/faqs';

  if (window.location.href.includes(slug) ) {
    const faqSelect = document.getElementById( 'faq-dropdown');
    if( typeof( faqSelect ) !== 'undefined'){
      faqSelect.addEventListener( 'change' , function( e ){
        const val = e.target.value;
        window.location.href = val;
      });
    }
  }
  
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          e.preventDefault();
  
          document.querySelector(this.getAttribute('href')).scrollIntoView({
              behavior: 'smooth'
          });
      });
  });

  let footer = document.querySelectorAll('.main-footer');
    function waitlistButton () {
        $('.join-waitlist').toggleClass('hide');
    }
    ScrollTrigger.create({
        trigger: footer,
        markers: false,
        start: "150px bottom",
        onEnter: waitlistButton,
        onLeaveBack: waitlistButton
    });
}
  

export default FaqsFilter;